import Marquee from "react-fast-marquee";
import { REVIEWS } from "@/data/content";

const GoogleG = ({ className = "w-5 h-5" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden>
    <path
      fill="#4285F4"
      d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.4 6.1 29.5 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20c11 0 19.6-8 19.6-20 0-1.3-.1-2.3-.4-3.5z"
    />
    <path
      fill="#34A853"
      d="M6.3 14.1l6.6 4.8C14.7 15.5 19 12 24 12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.4 6.1 29.5 4 24 4 16.3 4 9.7 8.4 6.3 14.1z"
    />
    <path
      fill="#FBBC05"
      d="M24 44c5.4 0 10.3-1.8 14.1-5l-6.5-5.5C29.6 35 26.9 36 24 36c-5.3 0-9.7-3.4-11.3-8l-6.6 5.1C9.5 39.6 16.2 44 24 44z"
    />
    <path
      fill="#EA4335"
      d="M43.6 20.5H42V20H24v8h11.3c-.7 2-2 3.7-3.7 5l6.5 5.5c-.5.4 7.5-5.5 7.5-14.5 0-1.3-.1-2.3-.4-3.5z"
    />
  </svg>
);

const Stars = ({ count = 5 }) => (
  <div className="flex gap-0.5" aria-label={`${count} of 5 stars`}>
    {[...Array(count)].map((_, i) => (
      <svg key={i} viewBox="0 0 24 24" fill="#FBBC04" className="w-4 h-4">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
      </svg>
    ))}
  </div>
);

function ReviewCard({ r }) {
  return (
    <div
      className="w-[340px] md:w-[380px] mx-4 bg-white rounded-2xl border border-[#e7e5df] p-6 shadow-[0_2px_10px_rgba(0,0,0,0.04)] relative"
      data-testid="google-review-card"
    >
      <GoogleG className="w-5 h-5 absolute top-5 right-5 opacity-90" />
      <div className="flex items-center gap-3">
        <div
          className="h-11 w-11 rounded-full flex items-center justify-center text-white font-bold text-lg"
          style={{ background: r.color }}
          aria-hidden
        >
          {r.initial}
        </div>
        <div>
          <div className="font-bold text-[#1c1917] text-[15px] leading-tight">
            {r.name}
          </div>
          {r.localGuide ? (
            <div className="text-[11px] text-[#57534e] flex items-center gap-1">
              Local Guide ·{" "}
              <span className="text-[#1a73e8]">verified</span>
            </div>
          ) : (
            <div className="text-[11px] text-[#57534e]">Tampa Bay, FL</div>
          )}
        </div>
      </div>
      <div className="flex items-center gap-2 mt-3">
        <Stars count={r.rating} />
        <span className="text-xs text-[#70757a]">{r.date}</span>
      </div>
      <p className="mt-3 text-[14.5px] leading-relaxed text-[#3c4043]">
        {r.body}
      </p>
    </div>
  );
}

export default function ReviewsMarquee() {
  return (
    <section
      id="reviews"
      className="relative bg-paper pt-6 pb-16 md:pb-24"
      data-testid="reviews-section"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#16a34a]">
              Loved by Tampa Bay
            </div>
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-[#1c1917] mt-2 tracking-tight">
              5.0 stars on Google.{" "}
              <span className="text-[#57534e]">Earned, not bought.</span>
            </h2>
          </div>
          <a
            href="https://www.google.com/maps/place/ProCraft+Solutions/@28.1876187,-82.7647886,14z"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 h-11 px-5 rounded-full bg-white border border-[#e7e5df] font-bold text-sm hover:border-[#16a34a] hover:text-[#16a34a] transition"
            data-testid="reviews-google-link"
          >
            <GoogleG className="w-4 h-4" />
            See all on Google
          </a>
        </div>
      </div>

      <div className="marquee-mask" data-testid="reviews-marquee">
        <Marquee speed={42} gradient={false} pauseOnHover>
          {REVIEWS.map((r, i) => (
            <ReviewCard key={`r1-${i}`} r={r} />
          ))}
        </Marquee>
        <div className="h-4" />
        <Marquee speed={32} direction="right" gradient={false} pauseOnHover>
          {REVIEWS.slice().reverse().map((r, i) => (
            <ReviewCard key={`r2-${i}`} r={r} />
          ))}
        </Marquee>
      </div>
    </section>
  );
}
